export default function validation(profile) {
    let errors = {}
    const email_pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const phone_pattern =/^\d{10}$/
    var status = true;


    if (profile.name["first_name"] ==="") {
        status = false;
        errors.first_name = "Name should not be empty"
    }
    if ( profile.name["email"] === "") {
        status = false;
        errors.email= "Email should not be empty"
    }
    if (profile.name["email"] && !email_pattern.test(profile.name["email"])) {
        status = false;
        errors.email = "Invalid Email Address"
    }

    if (profile.name["phone"]  === "") {
        status = false;
        errors.phone= "Phone should not be empty"
    }
    if (profile.name["phone"] && !phone_pattern.test(profile.name["phone"])){
        status = false;
        errors.phone = "Enter 10 Digit Only!!"
    }
    if (profile.V_jobfair=== "" | profile.V_jobfair  === null) {
        status = false;
        errors.V_jobfair= "Select Job Fair"
    }
    if (profile.V_companyname=== "" || profile.V_companyname  === null ) {
        status = false;
        errors.V_companyname= "Select Company"
    }


   

    return {'errors':errors,'status':status};
}